/**
 * Как принятые из документов строки ложатся в дело. Одно правило и для
 * загрузки в самих разделах, и для общего экрана в «Должнике».
 */

import type { CaseProfile, Creditor } from '@bd/domain';
import type { AcceptedProperty } from './PropertyDocumentsImport.js';

/** Кредиторы: пустые строки, заведённые впрок, уступают место строкам из документов. */
export function withCreditors(p: CaseProfile, rows: Creditor[]): CaseProfile {
  return { ...p, creditors: [...p.creditors.filter((c) => c.name.trim() || c.amountDebt > 0), ...rows] };
}

/** Имущество: то же для строк описи; недвижимость или транспорт из выписок — имущество зарегистрировано. */
export function withProperty(p: CaseProfile, accepted: AcceptedProperty): CaseProfile {
  return {
    ...p,
    property: {
      ...p.property,
      hasProperty: p.property.hasProperty || accepted.realty.length > 0 || accepted.vehicles.length > 0,
      realty: [...p.property.realty.filter((r) => r.cadastralNumber.trim() || r.address.trim()), ...accepted.realty],
      vehicles: [...p.property.vehicles.filter((v) => v.model.trim()), ...accepted.vehicles],
      accounts: [...p.property.accounts.filter((a) => a.bankName.trim() || a.balance > 0), ...accepted.accounts],
    },
  };
}

/** Уже внесённое — чтобы разбор не предлагал его второй раз: УИД договоров и ключи имущества. */
export function existingKeys(p: CaseProfile): string[] {
  return [
    ...p.creditors.map((c) => c.sourceUid).filter((uid): uid is string => Boolean(uid)),
    ...p.property.realty.filter((r) => r.cadastralNumber).map((r) => `realty:${r.cadastralNumber}`),
    ...p.property.vehicles.flatMap((v) => [v.registrationNumber, v.identificationNumber].filter(Boolean).map((k) => `vehicle:${k}`)),
    ...p.property.accounts.filter((a) => a.accountNumber).map((a) => `account:${a.accountNumber}`),
  ];
}
